export default {
  label: {
    listening: {
      title: 'Non-proprietary Filter',
      notClassified: 'Not Classified',
      groups: 'Groups',
      themes: 'Themes',
      tags: 'Tags',
    },
    sac: {
      title: 'Proprietary Filter',
    },
    page: {
      title: 'Pages Filter',
    },
    sacStatus: {
      title: 'Attendance Filter',
      descriptionPart1: 'Component filters take precedence over global ones. Note: the ',
      descriptionPart2: ' filter does not override the global status filter. The ',
      descriptionPart3: ' filter overrides the global status filter.',
      statusTransitionOld: 'Status transition (old)',
      statusTransitionNew: 'Status transition (new)',
      statusTransitionCurrent: 'Status transition (current)',
    },
    comparative: {
      title: 'Comparative Filter',
      notClassified: 'Not Classified',
      groupsLabel: 'Groups',
    },
    category: {
      title: 'Category',
      placeholder: 'None',
    },
    tagView: {
      title: 'Tags View',
      button_clear: 'Clear View',
    },
    sacListening: {
      title: 'Proprietary + Non-proprietary Filter',
      listeningSession: 'Non-proprietary',
      sacSession: 'Proprietary',
      notClassified: 'Not Classified',
      groups: 'Groups',
      themes: 'Themes',
      tags: 'Tags',
    },
    sacFilter: {
      notClassified: 'Not Classified',
      groups: 'Groups',
      noGroups: 'No Groups',
      themes: 'Themes',
      tags: 'Tags',
      repliers: 'Agents',
      status: 'Status',
    },
    blip: {
      title: 'Blip Filter',
      channels: 'Channels',
      queues: 'Queues',
      attendants: 'Attendants',
      tags: 'Tags',
      scheduling: 'Scheduling',
      campaignName: 'Campaign Name',
    },
    generic: {
      notClassified: 'Not Classified',
      groups: 'Groups',
      themes: 'Themes',
      tags: 'Tags',
    },
    button: {
      applyLabel: 'Apply',
      clearFilter: 'Clear all filters',
      clearchange: 'Revert recent changes',
    },
    dataTypeLabel: {
      listening: 'Non-proprietary data',
      sac: 'Proprietary data',
      page: 'Page metrics',
      blip: 'BLIP',
      'sac-listening': 'Proprietary + Non-proprietary',
      custom: 'Custom',
      static: 'Complementary',
      'sac-status': 'Smart Care',
      filterPrefix: 'Filter',
    },
  },
};
